export default __webpack_public_path__ + "static/media/schedule.7cd8019f.svg";